<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication"><span><i>Dedicated to the memory</i></span></p>
<p class="center"><span><i>of Robert D. Sampson, whose love of the genre —</i></span></p>
<p class="center"><span><i>and his kindness to me —lasted until the very end.</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3dedication.vue?6efa35c8